import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {Checkbox} from 'semantic-ui-react';
import withClickOutside from 'react-onclickoutside';
import {hideOrShowActiveField} from '../../Common/actions/Field';
import {getFieldPack, hideOrShowPackages} from '../actions/Packages';
import {getLocalizedText, placeholders, texts} from '../../../../constants/TextConst';
import {MenuProps} from './DesignMenu';
import packageConsts from '../../../../constants/PackageConsts';
import {AnimatedActionSubmenu} from '../../../../components/Common/ActionsMenu/ActionSubmenu';

@observer
class HideMenu extends Component<MenuProps & any, any> {
    constructor(props) {
        super(props);

        this.state = {
            checked: null
        };

        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleCheckChange(e, option) {
        const {field} = this.props;
        const {value} = option;
        this.setState({checked: value});

        if (value === 'formHide') {
            hideOrShowActiveField(field);
            this.handleClose();
        } else if (value === 'packageHide') {
            const resetChecked = () => {
                this.setState({checked: null});
            };
            hideOrShowPackages(field, this.handleClose, resetChecked);
        }
    }

    handleClickOutside() {
        this.handleClose();
    }

    handleClose() {
        const {closeSubmenu} = this.props;
        this.setState({checked: null});
        closeSubmenu();
    }

    render() {
        const {field} = this.props;
        const {hidden} = field;
        const activeFieldPack = getFieldPack(field);
        const packageTitle = activeFieldPack ? activeFieldPack.title : '';
        const packageHidden = activeFieldPack && activeFieldPack.hidden;
        const help = activeFieldPack ? activeFieldPack.help : '';
        const allPackageTxt =
            getLocalizedText(texts.allPackage) &&
            getLocalizedText(texts.allPackage).replace(
                placeholders.activeFieldPackTitle,
                packageTitle
            );

        return (
            <AnimatedActionSubmenu open={this.props.open}>
                <div className="checkbox-area">
                    <Checkbox
                        radio
                        label={`${
                            hidden ? getLocalizedText(texts.show) : getLocalizedText(texts.hide)
                        } ${getLocalizedText(texts.thisForm)}`}
                        name="checkboxRadioGroup"
                        value="formHide"
                        checked={this.state.checked === 'formHide'}
                        onChange={this.handleCheckChange}
                    />
                </div>
                {/* basic package and package "not assigned permanently" couldn't be hidden;
					here also comes the case when the entity doesn't belong to any package */}
                {!!hidden === packageHidden &&
                    field.packId !== packageConsts.BASIC_PAC_ID &&
                    field.packId !== packageConsts.PERM_UNASSIGNED_PAC_ID &&
                    field.packId !== packageConsts.NO_PACKAGE && (
                        <div className="checkbox-area">
                            <Checkbox
                                radio
                                label={`${
                                    hidden
                                        ? getLocalizedText(texts.show)
                                        : getLocalizedText(texts.hide)
                                } ${allPackageTxt} ${getLocalizedText(texts.yourPriorityTxt)}`}
                                name="checkboxRadioGroup"
                                value="packageHide"
                                checked={this.state.checked === 'packageHide'}
                                onChange={this.handleCheckChange}
                            />
                            <div className="explanation">{help}</div>
                        </div>
                    )}
            </AnimatedActionSubmenu>
        );
    }
}

const HideSubmenu = withClickOutside(HideMenu, {outsideClickIgnoreClass: 'action-tab selected'});

export default HideSubmenu;
